export default "__VITE_ASSET__8d8d1e8f__"